// SERVER_URL is read straight from `process.env` rather than the validated `env`
// module on purpose: importing `env` pulls its Zod schema — which runs
// `.parse(process.env)` at module load — into any client bundle, throwing a
// ZodError in the browser where the required server vars are absent. A plain
// `process.env.X` access just yields `undefined` client-side, keeping every
// consumer (e.g. MediaElement) safe inside client components. Mirrors src/proxy.ts.
const INTERNAL_HOSTNAMES = new Set<string>(['webfront.thesalon.app', 'webfront.frively.com']);

const serverUrl = process.env.SERVER_URL;
if (serverUrl) {
  try {
    INTERNAL_HOSTNAMES.add(new URL(serverUrl).hostname);
  } catch {
    // Ignore an unparseable SERVER_URL — the hard-coded hosts still apply.
  }
}

/**
 * Is this host one of ours? `webfront.thesalon.app` is a legacy host that still
 * serves uploads, so URLs persisted against it are internal, not third-party.
 */
export const isInternalHostname = (hostname: string): boolean => INTERNAL_HOSTNAMES.has(hostname);

export function makeRelativeUrl(url: string | URL): string {
  try {
    const parsedUrl = typeof url === 'string' ? new URL(url) : url;

    if (isInternalHostname(parsedUrl.hostname)) {
      return parsedUrl.pathname + parsedUrl.search;
    }

    return parsedUrl.toString();
  } catch {
    return url.toString();
  }
}
